import type { GameMeta } from "../../common/gameMeta.js";

export const meta = {
	name: "Tile Tangle",
	minPlayers: 1,
	maxPlayers: 4,
	description: "Unravel the tiles and find the path!",
	instructions: "Slide the tiles to reassemble the picture!",
	mobileBrowserCompatible: true,
} satisfies GameMeta;
